import { useEffect, useMemo, useRef, useState } from 'react'

const useInfinitiScroll = ({
  root = null,
  target,
  threshold = 1,
  rootMargin = '0px',
  targetArray,
  endPoint = 1,
}) => {
  const [count, setCount] = useState(0)
  const currentChid = useRef(null)

  const observer = useMemo(() => {
    return new IntersectionObserver(
      (entries, observer) => {
        if (target?.current === null) return

        if (entries[0].isIntersecting) {
          setCount((prevVal) => prevVal + 1)
          observer.disconnect()
        }
      },
      {
        root,
        rootMargin,
        threshold,
      },
    )
  }, [root, rootMargin, threshold, target])

  useEffect(() => {
    if (target?.current === null) return

    const observeChild = target.current.children[target.current.children.length - endPoint]
    if (observeChild && currentChid.current !== observeChild) {
      currentChid.current = observeChild
      observer.observe(observeChild)
    }

    return () => {
      const { current } = target
      if (current !== null && observer) {
        observer.unobserve(current)
      }
    }
  }, [endPoint, targetArray, observer, target])

  return [count, setCount]
}

export default useInfinitiScroll
